import type { RetentionMode } from '@sentinel/shared';
import { Button, Modal } from '@sentinel/ui';
import { useTranslation } from 'react-i18next';

const K = 'console.settings.retention';

interface Props {
  /** The mode to switch to; null = closed. */
  mode: RetentionMode | null;
  busy: boolean;
  onClose: () => void;
  onConfirm: (mode: RetentionMode) => void;
}

/** Switching the platform run lists what changes (rule 17): deletion cannot be undone, going
 *  back to preview does not bring back what was deleted. */
export function PlatformRetentionModal({ mode, busy, onClose, onConfirm }: Props) {
  const { t } = useTranslation();
  if (mode === null) return null;
  const consequences = t(`${K}.confirm.${mode}.consequences`, { returnObjects: true }) as string[];
  return (
    <Modal
      open
      title={t(`${K}.confirm.${mode}.title`)}
      icon="warning"
      onClose={onClose}
      closeLabel={t('common.actions.close')}
      footer={
        <>
          <Button onClick={onClose}>{t('common.actions.cancel')}</Button>
          <Button
            variant={mode === 'active' ? 'danger' : 'primary'}
            disabled={busy}
            onClick={() => onConfirm(mode)}
          >
            {t(`${K}.switch.${mode}`)}
          </Button>
        </>
      }
    >
      <p>
        <b>{t(`${K}.confirm.consequencesTitle`)}</b>
      </p>
      <ul className="consequences">
        {consequences.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    </Modal>
  );
}
